import { useGameStore, useJwt, EventBus } from '@campus/core';
import { Button, Icon } from '../ds/index.js';

/**
 * PodiumHUD — mode scène : qui présente, lever la main (public),
 * liste des mains levées avec « Donner la parole » (personne qui présente).
 */
export function PodiumHUD() {
  const podiumSpeakerId = useGameStore((s) => s.podiumSpeakerId);
  const podiumSpeakerName = useGameStore((s) => s.podiumSpeakerName);
  const raisedHands = useGameStore((s) => s.raisedHands);
  const jwt = useJwt();

  if (!podiumSpeakerId) return null;

  // Decode local userId
  let localUserId = '';
  try {
    if (jwt) localUserId = (JSON.parse(atob(jwt.split('.')[1]!)) as { sub: string }).sub;
  } catch { /* */ }

  const isSpeaker = localUserId === podiumSpeakerId;

  return (
    <div style={{ width: 280, maxWidth: '100%', display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div className="pl-pop" role="status" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', fontSize: 13, fontWeight: 500, borderColor: 'var(--color-warning)' }}>
        <Icon name="mic" size={16} />
        <span style={{ flex: 1 }}>{isSpeaker ? 'Tu as la parole' : `${podiumSpeakerName} a la parole`}</span>
        {!isSpeaker && <Button variant="secondary" size="sm" onClick={() => EventBus.emit('ui:hand-raise', {})}>Lever la main</Button>}
      </div>

      {isSpeaker && raisedHands.length > 0 && (
        <div className="pl-pop" style={{ padding: 8 }}>
          <p className="pl-menu-label" style={{ margin: 0 }}>Mains levées · {raisedHands.length}</p>
          {raisedHands.map((h) => (
            <div key={h.userId} style={{ display: 'flex', alignItems: 'center', gap: 10, minHeight: 40, padding: '0 6px' }}>
              <span style={{ flex: 1, fontSize: 13, fontWeight: 500 }}>{h.displayName}</span>
              <Button variant="primary" size="sm" onClick={() => EventBus.emit('ui:hand-grant', { userId: h.userId })}>Donner la parole</Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
